import {zodObjectDocumentUpload} from '@/components/Helpers/validationHelpers.ts';
import {normalizeAvailability} from '@/shared/availability.ts';
import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form400Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        birthCertificateAvailability: z.coerce
            .string({message: `${t('sef400CertStatus')} ${t('requiredError')}`})
            .nullable()
            .refine(availability => normalizeAvailability(availability) !== null, {
                message: `${t('sef400CertStatus')} ${t('requiredError')}`,
            }),
        birthCertificateAvailabilityWhy: z
            .string()
            .nullish()
            .transform(bcaw => (bcaw === undefined ? null : bcaw)),
        parentIdAvailability: z.coerce
            .string({message: `${t('sef400IdStatus')} ${t('requiredError')}`})
            .nullable()
            .refine(availability => normalizeAvailability(availability) !== null, {
                message: `${t('sef400IdStatus')} ${t('requiredError')}`,
            }),
        parentIdAvailabilityWhy: z
            .string()
            .nullish()
            .transform(piaw => (piaw === undefined ? null : piaw)),
        documents400: z.array(zodObjectDocumentUpload),
    });

export const form400Refine = (
    schema: ReturnType<typeof form400Schema>,
    t: TFunction<'translation', undefined>,
) => {
    return schema
        .refine(
            formData => {
                return formData.birthCertificateAvailability === 'false'
                    ? !!formData.birthCertificateAvailabilityWhy
                    : true;
            },
            {
                message: `${t('sefBirthCert')} is required.`,
                path: ['birthCertificateAvailabilityWhy'],
            },
        )
        .refine(
            formData => {
                return formData.parentIdAvailability === 'false'
                    ? !!formData.parentIdAvailabilityWhy
                    : true;
            },
            {
                message: `${t('sefParentId')} is required.`,
                path: ['parentIdAvailabilityWhy'],
            },
        );
};
